import { CardNumberElement } from "@stripe/react-stripe-js";
import { FaInfoCircle } from "react-icons/fa";

// "Create Your API Profile" section. Billing address lives in
// billingAddressFields below, under the "Billing Information" heading.
export const inputWithoutLogin = [
  {
    type: "text",
    placeholder: "Enter first name",
    name: "firstName",
    label: "First Name",
  },
  {
    type: "text",
    placeholder: "Enter last name",
    name: "lastName",
    label: "Last Name",
  },
  {
    type: "email",
    placeholder: "Enter email address",
    name: "email",
    label: "Email Address",
  },
  {
    type: "password",
    name: "password",
    label: "Password",
    placeholder: "Password at least 6 characters",
  },
  {
    type: "password",
    name: "confirmPassword",
    label: "Confirm Password",
    placeholder: "Password again please",
  },
  {
    type: "text",
    placeholder: "Create an Account ID",
    name: "userName",
    label: "Account ID",
  },
  {
    type: "tel",
    autocomplete: "tel",
    name: "phone",
    placeholder: "Enter phone number",
    label: "Phone Number",
  },
  {
    type: "date",
    placeholder: "Date of birth",
    name: "dateOfBirth",
    label: "Date of Birth",
  },
  {
    type: "text",
    name: "companyName",
    placeholder: "Enter company name or Self",
    label: "Company",
  },
];
export const inputWhenLogin = [
  {
    type: "text",
    placeholder: "First Name",
    name: "firstName",
    label: "First Name",
  },
  {
    type: "text",
    placeholder: "Last Name",
    name: "lastName",
    label: "Last Name",
  },
  {
    type: "tel",
    autocomplete: "tel",
    name: "phone",
    placeholder: "Enter phone number",
    label: "Phone Number",
  },
  {
    type: "text",
    name: "companyName",
    placeholder: "Enter company name or Self",
    label: "Company",
  },
];

// "Billing Information" section — rendered with the card fields, so it only
// appears when a new card is being entered. `md`/`colClass` put State and ZIP
// on one row with a gutter between them.
export const billingAddressFields = [
  {
    type: "text",
    name: "line1",
    placeholder: "Street address",
    label: "Billing Address",
    md: "12",
  },
  { type: "text", name: "city", placeholder: "City", label: "City", md: "12" },
  {
    type: "select",
    name: "state",
    placeholder: "Select state",
    label: "State",
    md: "6",
    // gutter only once the pair is side by side (md+); flush when stacked
    colClass: "p-0 pr-md-2",
  },
  {
    type: "text",
    name: "postalCode",
    placeholder: "ZIP code",
    label: "ZIP Code",
    md: "6",
    colClass: "p-0 pl-md-2",
  },
];
// Tokenize the card and attach the billing address for AVS + Stripe Tax.
// With split Elements, createToken(CardNumberElement) automatically uses the
// linked expiry/CVC fields from the same <Elements> group. US-only for now.
export const getStripeToken = async (elements, stripe, billing = {}) => {
  const cardElement = elements.getElement(CardNumberElement);

  const result = await stripe.createToken(cardElement, {
    ...(billing.name ? { name: billing.name } : {}),
    address_line1: billing.line1,
    address_city: billing.city,
    address_state: billing.state,
    address_zip: billing.postalCode,
    address_country: "US",
  });

  if (result.error) {
    alert(result.error.message);
    return;
  }
  return result.token.id;
};

export const planCardData = [
  {
    header: "Great for golf courses",
    id: "api-single",
    active: true,
    subTitle: "Access to all data for any one golf course in the database",
    currency: "usd",
    nickname: "Single Golf Course",
    recurring: {
      interval: "month",
      trial_period_days: null,
    },
    unit_amount: 900 / 100,
    btnText: "Sign Up",
    path: "/api/subscribe/single",
    icon: <FaInfoCircle />,
    callPerMon: "10,000 calls per month",
    additionalApi: "Additional API calls $0.005 per call",
    accessCourse: "Access to a single course",
    support: "Included Support",
    bussinessDay: "2 business days response time*",
    submit: "Submit updates",
    report: "Report errors",
    description: "",
  },
  {
    header: "Great for app developers",
    id: "api-all",
    active: true,
    subTitle: "Access to all data for all golf courses in the database",
    btnText: "Sign Up",
    currency: "usd",
    nickname: "All Golf Courses",
    recurring: {
      interval: "month",
      trial_period_days: null,
    },
    unit_amount: 39900 / 100,
    path: "/api/subscribe/all",
    callPerMon: "100,000 calls per month",
    additionalApi: "Daily limits apply. Additional API calls $0.005 per call",
    accessCourse: "Access to all courses",
    icon: <FaInfoCircle />,
    support: "Included Support",
    bussinessDay: "2 business days response time*",
    newCourse: "5 new course requests per month",
    submit: "Submit updates",
    report: "Report errors",
    description:
      "Included with this plan is access to data for all golf courses in the database. Our staff will continue to add courses and manage the course data.",
  },
  {
    header: "Great for offline applications",
    id: "static-data",
    nickname: "Static Data",
    subTitle:
      "Get a snapshot of the entire database for use without monthly API fees",
    unit_amount: "120,000**",
    recurring: {
      interval: "one-time fee",
      trial_period_days: null,
    },
    btnText: "Contact us",
    callPerMon: "No API calls needed",
    additionalApi: "You own/host/embed the data",
    accessCourse: "Access to all courses",
    description:
      "You will receive a copy of the current database in its entirety**.",
    icon: <FaInfoCircle />,
    support: "Included Support",
    bussinessDay: "1 business day response time*",
    newCourse: "10 new course requests per month",
    submit: "Submit updates",
    report: "Report errors",
    maintenanceFees: "Optional annual database updates for 20% maintenance fee",
    // businessNeed:
    //     "**Based on purchase of complete dataset for all golf courses in the database. Data can be customized and price reflected to fit your business needs.",
    active: true,
    path: "/api/support",
  },

  // {
  //     header: "Great for golf courses",
  //     title: "Single Golf Course",
  //     subTitle:
  //         "Access to all data for any one golf course in the database",
  //     price: "$9",
  //     month: "per month",
  //     btnText: "Sign Up",
  //     callPerMon: "10,000 calls per month",
  //     additionalApi: "Additional API calls $0.005 per call",
  //     accessCourse: "Access to a single course",
  //     support: "Included Support",
  //     bussinessDay: "2 business days response time*",
  //     submit: "Submit updates",
  //     report: "Report errors",
  //     active: true,
  //     path: "/api/subscribe/single",
  // },

  // {
  //     header: "Great for app developers",
  //     title: "All Golf Courses",
  //     subTitle: "Access to all data for all golf courses in the database",
  //     price: "$399",
  //     month: "per month",
  //     btnText: "Sign Up",
  //     callPerMon: "100,000 calls per month",
  //     additionalApi: "Additional API calls $0.005 per call",
  //     accessCourse: "Access to all courses",
  //     description:
  //         "Included with this plan is access to data for all golf courses in the database. Our staff will continue to add courses and manage the course data.",
  //     icon: <FaInfoCircle />,
  //     support: "Included Support",
  //     bussinessDay: "2 business days response time*",
  //     newCourse: "5 new course requests per month",
  //     submit: "Submit updates",
  //     report: "Report errors",
  //     active: true,
  //     path: "/api/subscribe/all",
  // },
];
